document.addEventListener('DOMContentLoaded', function() {

  /* === Fade-in animation on scroll === */
  var fadeEls = document.querySelectorAll('.landing-fade-in');
  if (fadeEls.length) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    fadeEls.forEach(function(el) { obs.observe(el); });
  }

  /* === FAQ Accordion === */
  document.querySelectorAll('.landing-faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.landing-faq__item');
      var isActive = item.classList.contains('active');
      item.closest('.landing-faq__list').querySelectorAll('.landing-faq__item').forEach(function(i) { i.classList.remove('active'); });
      if (!isActive) item.classList.add('active');
    });
  });

  /* === Before/After Slider === */
  document.querySelectorAll('.landing-before-after__wrapper').forEach(function(wrapper) {
    var isDragging = false;
    var afterImg = wrapper.querySelector('.landing-before-after__img--after');
    var slider = wrapper.querySelector('.landing-before-after__slider');
    function move(x) {
      var rect = wrapper.getBoundingClientRect();
      var pct = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
      if (afterImg) afterImg.style.clipPath = 'inset(0 0 0 ' + (pct * 100) + '%)';
      if (slider) slider.style.left = (pct * 100) + '%';
    }
    wrapper.addEventListener('mousedown', function(e) { isDragging = true; move(e.clientX); });
    document.addEventListener('mousemove', function(e) { if (isDragging) move(e.clientX); });
    document.addEventListener('mouseup', function() { isDragging = false; });
    wrapper.addEventListener('touchstart', function(e) { isDragging = true; move(e.touches[0].clientX); }, {passive: true});
    wrapper.addEventListener('touchmove', function(e) { if (isDragging) move(e.touches[0].clientX); }, {passive: true});
    wrapper.addEventListener('touchend', function() { isDragging = false; });
  });

  /* === Sticky CTA === */
  var stickyCta = document.querySelector('.landing-sticky-cta');
  var heroSection = document.querySelector('.landing-hero');
  if (stickyCta && heroSection) {
    var stickyObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { stickyCta.classList.remove('visible'); }
        else { stickyCta.classList.add('visible'); }
      });
    }, { threshold: 0 });
    stickyObs.observe(heroSection);
  }

  /* === Countdown Timer === */
  document.querySelectorAll('[data-countdown]').forEach(function(el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) end = Date.now() + 86400000;
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) return;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var hEl = el.querySelector('[data-hours]');
      var mEl = el.querySelector('[data-minutes]');
      var sEl = el.querySelector('[data-seconds]');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* === Add to Cart === */
  document.querySelectorAll('[data-lp-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var vid = this.getAttribute('data-variant-id');
      if (!vid) return;
      var self = this;
      self.textContent = 'Agregando...';
      self.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
      }).then(function(r) { return r.json(); }).then(function() {
        self.textContent = 'Agregado \u2713';
        setTimeout(function() { window.location.href = '/cart'; }, 800);
      }).catch(function() {
        self.textContent = 'Error - Reintentar';
        self.disabled = false;
      });
    });
  });

  /* === Urgency bar animation === */
  document.querySelectorAll('.landing-urgencia__bar-fill').forEach(function(bar) {
    var w = bar.getAttribute('data-width') || '75';
    setTimeout(function() { bar.style.width = w + '%'; }, 500);
  });

});